import { render, staticRenderFns } from "./Dashteacher.vue?vue&type=template&id=462e8d9f&"
import script from "./Dashteacher.vue?vue&type=script&lang=js&"
export * from "./Dashteacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports